module.exports = __webpack_public_path__ + "img/exclamation_mark_icon.996dbfd0.svg";